<template>
    <div class="home">
        <div class="banner">
            <el-carousel height="694rem" trigger="click" :interval="5000" arrow="never">
                <el-carousel-item>
                    <div class="banner_container">
                        <div class="main_content banner_container1">
                            <div class="banner_title">快麦云标签打印机 E41G</div>
                            <div class="banner_text">热销爆款 批量打印 大容量纸仓</div>
                            <img class="banner_img" src="./images/E41.png" alt="img">
                            <a class="banner_btn"
                               @click="openNew('https://cloudprint.kuaimai.com/#/productCenter/WiFi/E41G')">了解更多</a>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="home_container home_container_write">
            <div class="main_content">
                <div class="home_title">快麦打印机</div>
                <div class="km-printer-list">
                    <div class="km-printer">
                        <div class="km-printer-title">快递面单打印机</div>
                        <img class="km-printer-img" src="../printCenter/MianDan/KM-202M/images/202MD.752.png" alt="img">
                        <div class="km-printer-name">KM-202M</div>
                        <div class="km-printer-btn" @click="$router.push('/printCenter/MianDan/km202m')">查看详情</div>
                    </div>
                    <div class="km-printer">
                        <div class="km-printer-title">标签打印机</div>
                        <img class="km-printer-img" src="../printCenter/BiaoQian/KM118MEG/images/KM118MEG.png" alt="img">
                        <div class="km-printer-name">KM118MEG系列</div>
                        <div class="km-printer-btn">查看详情</div>
                    </div>
                    <div class="km-printer">
                        <div class="km-printer-title">小票打印机</div>
                        <img class="km-printer-img" src="../printCenter/PiaoJu/DP158/images/1.png" alt="img">
                        <div class="km-printer-name">DP158</div>
                        <div class="km-printer-btn" @click="$router.push('/printCenter/PiaoJu/DP158')">查看详情</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="home_container home_container_gray">
            <div class="main_content">
                <div class="home_title">快麦云打印机</div>
                <div class="km-cloud-printer">
                    <div class="km-cloud-printer-content">
                        免驱动安装&emsp;&emsp;支持异地远程<br/>
                        多人跨端打印<br/>
                        开放API接口<br/>
                        可对接PC端WEB<br/>
                        移动端&emsp;&emsp;PC应用
                    </div>
                    <div class="km-printer-btn" @click="openNew('https://cloudprint.kuaimai.com/#/home')">查看详情</div>
                </div>
            </div>
        </div>
        <div class="home_container home_container_bg1">
            <div class="main_content">
                <div class="home-bg1">
                    <div class="home-bg1-left">
                        <div class="home-bg1-title">服务/支持</div>
                        <div class="home-bg1-text">给你的服务是看得见的温度</div>
                    </div>
                    <div class="home-bg1-list">
                        <div class="home-bg1-item" @click="$router.push('/device')">
                            <div class="home-bg1-item-title">驱动下载</div>
                            <div class="home-bg1-item-text">下载番茄打印管家，<br/>驱动安装自动化。</div>
                            <img class="home-bg1-item-icon" src="./images/bg1-icon1.png" alt="icon">
                        </div>
                        <div class="home-bg1-item" @click="$router.push('/afterSalesService')">
                            <div class="home-bg1-item-title">售后服务</div>
                            <div class="home-bg1-item-text">机器维修、<br/>维修进度查询等。</div>
                            <img class="home-bg1-item-icon" src="./images/bg1-icon2.png" alt="icon">
                        </div>
                        <div class="home-bg1-item" @click="openNew('https://dyj-old.kuaimai.com/problem/index.html')">
                            <div class="home-bg1-item-title">常见问题</div>
                            <div class="home-bg1-item-text">机器安装、打印设置、<br/>异常问题处理。</div>
                            <img class="home-bg1-item-icon" src="./images/bg1-icon3.png" alt="icon">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="home_container home_container_bg2">
            <div class="main_content">
                <div class="home-bg2">
                    <div class="home-bg2-left">
                        <div class="home-bg2-item">
                            <div class="home-bg2-item-title">4,000,000 +</div>
                            <div class="home-bg2-item-text">累计售出打印机</div>
                        </div>
                        <div class="home-bg2-item">
                            <div class="home-bg2-item-title">200 +</div>
                            <div class="home-bg2-item-text">累计研发产品</div>
                        </div>
                        <div class="home-bg2-item">
                            <div class="home-bg2-item-title">20 +</div>
                            <div class="home-bg2-item-text">累计服务国家和地区</div>
                        </div>
                        <div class="home-bg2-item">
                            <div class="home-bg2-item-title">650,000 +</div>
                            <div class="home-bg2-item-text">累计服务客户数</div>
                        </div>
                    </div>
                    <div class="home-bg2-right">
                        <div class="home-bg2-title">快麦服务<br/>全球商家</div>
                        <div class="home-bg2-text">
                            快麦系列产品远销东南亚、<br/>
                            北美、欧洲等国家和地区，<br/>
                            为客户提供智能化打印解决方案。
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="home_container home_container_bg3">
            <div class="main_content">
                <div class="home-bg3">
                    <div class="home-bg3-item">
                        <div class="home-bg3-title">产品动态</div>
                        <img class="home-bg3-img" src="./images/bg3-1.png" alt="bg">
                        <div class="home-bg3-content1">关于快麦打印机KM-202外观升级的声明</div>
                        <div class="home-bg3-content2">
                            快麦打印机驱动教材安装视频<br/>
                            卸载补丁修复蓝屏问题
                        </div>
                        <div class="home-bg3-btn" @click="openNew('https://dyj-old.kuaimai.com/cpdt/index.html')">
                            查看更多
                        </div>
                    </div>
                    <div class="home-bg3-item">
                        <div class="home-bg3-title">行业资讯</div>
                        <img class="home-bg3-img" src="./images/bg3-2.png" alt="bg">
                        <div class="home-bg3-content1">打印机的常见故障主要由以下两大原因引起</div>
                        <div class="home-bg3-content2">
                            专业存折打印机的技术指标和特有功能<br/>
                            热敏打印机机和热转印机的区别是什么
                        </div>
                        <div class="home-bg3-btn" @click="openNew('https://dyj-old.kuaimai.com/xyzx/index.html')">
                            查看更多
                        </div>
                    </div>
                    <div class="home-bg3-item">
                        <div class="home-bg3-title">常见问题</div>
                        <img class="home-bg3-img" src="./images/bg3-3.png" alt="bg">
                        <div class="home-bg3-content1">KM-118打印机如何设置进纸长度</div>
                        <div class="home-bg3-content2">
                            KM-202BT连接不上打印机怎么办<br/>
                            KM-202M打印机异响如何处理
                        </div>
                        <div class="home-bg3-btn" @click="openNew('https://dyj-old.kuaimai.com/problem/index.html')">
                            查看更多
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import router from '@/router'

export default {
    name: "Home",
    data() {
        return {};
    },
    methods: {
        router() {
            return router
        }
    },
};
</script>

<style lang="scss" scoped>
.home {
    .banner {
        height: 694rem;

        .banner_container {
            height: 694rem;
            background: #232340;

            .banner_container1 {
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-end;
                height: 100%;
            }

            .banner_title {
                font-family: AppleSystemUIFont;
                font-size: 40rem;
                color: #FD6520;
                margin-bottom: 16rem;
                line-height: 58rem;
            }

            .banner_text {
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 24rem;
                color: #FFFFFF;
                line-height: 34rem;
                margin-bottom: 30rem;
            }

            .banner_img {
                margin-bottom: -228rem;
                width: 650rem;
                height: 592rem;
            }

            .banner_btn {
                position: absolute;
                left: 364rem;
                bottom: 104rem;
                display: block;
                width: 146rem;
                height: 50rem;
                border: 2rem solid #FD6520;
                font-size: 18rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #FD6520;
                line-height: 50rem;
                text-align: center;
                cursor: pointer;
                border-radius: 50rem;
            }
        }
    }

    .home_container {
        padding: 74rem 0 88rem 0;
        box-sizing: border-box;

        &.home_container_gray {
            background: #EEEEEE;
        }

        &.home_container_write {
            background: #FFFFFF;
        }

        &.home_container_bg1 {
            width: 100%;
            height: 505rem;
            background: url("./images/bg1.png") center center/ 1920rem 505rem no-repeat;
        }

        &.home_container_bg2 {
            width: 100%;
            height: 545rem;
            background: url("./images/bg2.png") center center/ 1920rem 545rem no-repeat;
        }

        &.home_container_bg3 {
            width: 100%;
            height: 670rem;
            background: url("./images/bg3.png") center center/ 1920rem 670rem no-repeat;
        }

        .home_title {
            display: block;
            text-align: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 40rem;
            color: #333333;
            line-height: 56rem;
        }

        .km-printer-list {
            margin-top: 26rem;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .km-printer {
                position: relative;
                box-sizing: border-box;
                padding-top: 33rem;
                width: 380rem;
                height: 550rem;
                background: #F5F5F5;
                border-radius: 20rem;
                z-index: 1;
                transition: all .3s;

                &::before {
                    position: absolute;
                    top: 0;
                    left: 0;
                    content: '';
                    width: 100%;
                    height: 100%;
                    box-shadow: -4rem 0 0 0 #FD6520;
                    border-radius: 20rem;
                    z-index: -1;
                }

                &:hover {
                    background: #FFFFFF;
                    box-shadow: 0 4rem 16rem 0 rgba(0, 0, 0, 0.16), 0 4rem 16rem 0 rgba(0, 0, 0, 0.16);

                    .km-printer-btn {
                        background: #FD6520 url("./images/arrow2.png") 117rem center / 26rem 26rem no-repeat;
                        color: #FFFFFF;
                    }
                }

                .km-printer-title {
                    box-sizing: border-box;
                    width: 231rem;
                    height: 66rem;
                    background: #FD6520;
                    border-radius: 0 60rem 60rem 0;
                    padding-left: 21rem;
                    font-family: AppleSystemUIFont;
                    font-size: 24rem;
                    color: #FFFFFF;
                    line-height: 66rem;
                    text-align: left;
                }

                .km-printer-img {
                    display: block;
                    margin: 38rem auto 0;
                    //width: 359rem;
                    height: 236rem;
                }

                .km-printer-name {
                    margin-top: 22rem;
                    font-family: AppleSystemUIFont;
                    font-size: 22rem;
                    color: #31314C;
                    line-height: 31rem;
                    text-align: center;
                }

                .km-printer-btn {
                    display: block;
                    margin: 23rem auto 0;
                    padding-right: 26rem;
                    width: 124rem;
                    height: 40rem;
                    background: #FFFFFF url("./images/arrow.png") 117rem center / 26rem 26rem no-repeat;
                    border-radius: 40rem;
                    border: 2rem solid #FD6520;
                    font-family: AppleSystemUIFont;
                    font-size: 16rem;
                    color: #FD6520;
                    line-height: 40rem;
                    text-align: center;
                    cursor: pointer;
                    transition: all .3s;
                }
            }
        }

        .km-cloud-printer {
            margin-top: 54rem;
            width: 1200rem;
            height: 457rem;
            background: url("./images/cloudPrinter.png") center center / 100% 100% no-repeat;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: center;


            .km-cloud-printer-content {
                margin-right: 81rem;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-end;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 26rem;
                color: #FFFFFF;
                line-height: 44rem;
                text-align: center;
            }

            .km-printer-btn {
                margin: 44rem 162rem 0 0;
                padding-right: 26rem;
                width: 124rem;
                height: 40rem;
                background: #FFFFFF url("./images/arrow.png") 117rem center / 26rem 26rem no-repeat;
                border-radius: 40rem;
                border: 2rem solid #262626;
                font-family: AppleSystemUIFont;
                font-size: 16rem;
                color: #FD6520;
                line-height: 40rem;
                text-align: center;
                cursor: pointer;
            }
        }

        .home-bg1 {
            margin-top: 38rem;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-between;

            .home-bg1-left {
                .home-bg1-title {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 64rem;
                    color: #FD6520;
                    line-height: 90rem;
                }

                .home-bg1-text {
                    margin-top: 34rem;
                    font-family: AppleSystemUIFont;
                    font-size: 24rem;
                    color: #FFFFFF;
                }
            }

            .home-bg1-list {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                gap: 19rem;

                .home-bg1-item {
                    box-sizing: border-box;
                    padding: 30rem 27rem 0;
                    width: 264rem;
                    height: 268rem;
                    background: #FFFFFF;
                    border-radius: 20rem;
                    cursor: pointer;

                    &:hover {
                        box-shadow: 0 -6rem 0 0 #FD6520;

                        .home-bg1-item-icon {
                            transform: scale(1.2);
                        }
                    }

                    .home-bg1-item-title {
                        margin-bottom: 10rem;
                        font-family: AppleSystemUIFont;
                        font-size: 24rem;
                        color: #333333;
                        line-height: 34rem;
                    }

                    .home-bg1-item-text {
                        margin-bottom: 39rem;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 500;
                        font-size: 18rem;
                        color: #666666;
                        line-height: 25rem;
                    }

                    .home-bg1-item-icon {
                        width: 64rem;
                        height: 64rem;
                    }
                }
            }
        }

        .home-bg2 {
            margin-top: 26rem;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-between;

            .home-bg2-left {
                width: 700rem;
                height: 400rem;
                display: grid;
                grid-template-columns: 50% 50%;
                grid-template-rows: 50% 50%;

                .home-bg2-item {

                    .home-bg2-item-title {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 500;
                        font-size: 48rem;
                        color: #FD6520;
                        line-height: 67rem;
                    }

                    .home-bg2-item-text {
                        margin-top: 5rem;
                        font-family: AppleSystemUIFont;
                        font-size: 24rem;
                        color: #FFFFFF;
                        line-height: 34rem;
                    }
                }
            }

            .home-bg2-right {
                .home-bg2-title {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 64rem;
                    color: #FD6520;
                    line-height: 90rem;
                }

                .home-bg2-text {
                    margin-top: 34rem;
                    font-family: AppleSystemUIFont;
                    font-size: 24rem;
                    color: #FFFFFF;
                    line-height: 34rem;
                }
            }
        }

        .home-bg3 {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .home-bg3-item {
                position: relative;
                box-sizing: border-box;
                width: 380rem;
                height: 503rem;
                padding: 30rem;
                background: #FFFFFF;
                border-radius: 20rem;
                z-index: 1;
                transition: all .3s;

                &::before {
                    position: absolute;
                    top: 0;
                    left: 0;
                    content: '';
                    width: 100%;
                    height: 100%;
                    box-shadow: 0 -4rem 0 0 #FD6520;
                    border-radius: 20rem;
                    z-index: -1;
                }

                &:hover {
                    background: #FFFFFF;
                    box-shadow: 0 4rem 16rem 0 rgba(0, 0, 0, 0.16), 0 4rem 16rem 0 rgba(0, 0, 0, 0.16);

                    .home-bg3-btn {
                        background: #FD6520 url("./images/arrow2.png") 117rem center / 26rem 26rem no-repeat;
                        color: #FFFFFF;
                    }
                }

                .home-bg3-title {
                    margin-bottom: 16rem;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 24rem;
                    color: #FD6520;
                    line-height: 34rem;
                    text-align: center;
                }

                .home-bg3-img {
                    margin-bottom: 18rem;
                    width: 320rem;
                    height: 200rem;
                }

                .home-bg3-content1 {
                    margin-bottom: 9rem;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 14rem;
                    color: #333333;
                    line-height: 20rem;
                }

                .home-bg3-content2 {
                    margin-bottom: 33rem;
                    font-family: AppleSystemUIFont;
                    font-size: 14rem;
                    color: #333333;
                    line-height: 30rem;
                }

                .home-bg3-btn {
                    float: right;
                    padding-right: 26rem;
                    width: 124rem;
                    height: 40rem;
                    background: #FFFFFF url("./images/arrow.png") 117rem center / 26rem 26rem no-repeat;
                    border-radius: 40rem;
                    border: 2rem solid #FD6520;
                    font-family: AppleSystemUIFont;
                    font-size: 16rem;
                    color: #FD6520;
                    line-height: 40rem;
                    text-align: center;
                    cursor: pointer;
                    transition: all .3s;
                }
            }
        }
    }
}
</style>
